var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 16,
    viewBox: "0 0 49 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.426 4.86857C25.3986 6.95813 27.3503 8.12412 28.8205 8.81744C30.331 9.52871 30.8384 9.98488 30.8324 10.621C30.8211 11.5945 29.6275 12.0242 28.5106 12.0409C26.5619 12.0701 25.4288 11.5317 24.5281 11.1246L23.8261 14.3034C24.7298 14.7064 26.4032 15.0578 28.1386 15.0732C32.212 15.0732 34.8769 13.1274 34.8914 10.1104C34.9073 6.28151 29.4186 6.06958 29.4561 4.35815C29.4691 3.83921 29.9808 3.28543 31.102 3.14462C31.657 3.0735 33.1891 3.01906 34.9261 3.79312L35.6078 0.717567C34.6737 0.388419 33.4731 0.0732422 31.9784 0.0732422C28.1444 0.0732422 25.4478 2.04559 25.426 4.86857ZM42.1587 0.338158C41.4149 0.338158 40.7881 0.758029 40.5083 1.40235L34.6896 14.8473H38.7601L39.5701 12.681H44.5441L45.0139 14.8473H48.6016L45.4709 0.338158H42.1587ZM42.7281 4.25763L43.9028 9.70599H40.6857L42.7281 4.25763ZM20.4908 0.338339L17.2823 14.8472H21.1611L24.3681 0.337976L20.4908 0.338339ZM14.7528 0.338339L10.7155 10.2137L9.08237 1.81678C8.89075 0.879419 8.134 0.338158 7.29363 0.338158H0.694L0.601562 0.759481C1.95644 1.04399 3.49581 1.50288 4.42844 1.99388C4.99919 2.29381 5.16194 2.556 5.34944 3.26873L8.44263 14.8473H12.5416L18.8258 0.338158L14.7528 0.338339Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.f3c80205975f6860b591f8ff35769bfe.svg";
export { ForwardRef as ReactComponent };